import { setDisplayErrorSnackBar } from "../../../../../features/userSlice";

export const dispatchSnackBarMessages = (
  messages: { message: string; type: string }[],
  dispatch: any
) => {
  if (messages.length === 0) return;

  // if only one message, dispatch as is
  if (messages.length === 1) {
    dispatch(setDisplayErrorSnackBar(messages[0]));
    return;
  }

  // if multiple, find if mixed (success + error)
  const hasSuccess = messages.some((m) => m.type === "success");
  const hasError = messages.some((m) => m.type === "error");

  const combinedMessage = messages.map((m) => m.message).join(" | ");

  dispatch(
    setDisplayErrorSnackBar({
      message: combinedMessage,
      type: hasError && hasSuccess ? "warning" : hasError ? "error" : "success",
    })
  );
};